// extracted by mini-css-extract-plugin
module.exports = {"container":"Comics_container__2SQgk","comic":"Comics_comic__2oyGi"};